module.exports = __webpack_public_path__ + "img/16_1.4da230ea.png";